var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationStatusRegistered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21967 5.21967C7.51256 4.92678 7.98744 4.92678 8.28033 5.21967L12.7803 9.71967C13.0732 10.0126 13.0732 10.4874 12.7803 10.7803C12.4874 11.0732 12.0126 11.0732 11.7197 10.7803L7.75 6.81066L3.78033 10.7803C3.48744 11.0732 3.01256 11.0732 2.71967 10.7803C2.42678 10.4874 2.42678 10.0126 2.71967 9.71967L7.21967 5.21967Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusRegistered);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iIzJGODBFRCIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4yMTk2NyA1LjIxOTY3QzcuNTEyNTYgNC45MjY3OCA3Ljk4NzQ0IDQuOTI2NzggOC4yODAzMyA1LjIxOTY3TDEyLjc4MDMgOS43MTk2N0MxMy4wNzMyIDEwLjAxMjYgMTMuMDczMiAxMC40ODc0IDEyLjc4MDMgMTAuNzgwM0MxMi40ODc0IDExLjA3MzIgMTIuMDEyNiAxMS4wNzMyIDExLjcxOTcgMTAuNzgwM0w3Ljc1IDYuODEwNjZMMy43ODAzMyAxMC43ODAzQzMuNDg3NDQgMTEuMDczMiAzLjAxMjU2IDExLjA3MzIgMi43MTk2NyAxMC43ODAzQzIuNDI2NzggMTAuNDg3NCAyLjQyNjc4IDEwLjAxMjYgMi43MTk2NyA5LjcxOTY3TDcuMjE5NjcgNS4yMTk2N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };